import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { IconButtonAnimated } from '../../../../components/resources';

const ButtonBack = ({ page, hasChanges, onBackConfirm }) => {
  
  // Definición del color de acento principal (Rojo de la app eatery)
  const ACCENT_RED = '#ff3b3b';

  return (
    <IconButtonAnimated
      size="small"
      aria-label="Volver a la página anterior" // Mejorar la accesibilidad
      // Mantener color inherit, pero la lógica de estilo va en sx
      color="inherit" 
      onClick={() => {
        if (hasChanges) {
          onBackConfirm();
        } else {
          page(false);
        }
      }}
      sx={{
        // Tamaño base más estándar y alineado
        width: 40,
        height: 40,
        padding: 0,
        borderRadius: '50%',
        color: '#6A6A6A', // Color de icono por defecto (Gris secundario)
        transition: 'all 0.2s ease',

        '&:hover': {
          color: ACCENT_RED, // Se vuelve rojo al hacer hover
          backgroundColor: 'rgba(255, 59, 59, 0.1)', // Fondo muy sutil en hover
        },
      }}
    >
      {/* Usamos un icono de Material UI que es más limpio y escalable */}
      <ArrowBackIosNewIcon sx={{ fontSize: 22 }} />
    </IconButtonAnimated>
  );
};

export default ButtonBack;
